export default __webpack_public_path__ + "static/media/icon-circle-plus.c23846be.png";